import React from 'react';
import { PlusIcon } from '@hero/web-icons';
import { cn } from '@hero/web-lib';
import { Button } from '../../ui/Button';
import { Spinner } from '../Spinner';

export interface ButtonCreateEntityProps {
  /** Button label, e.g. "Create Customer" */
  label: string;
  /** Click handler – opens the entity's create modal/drawer */
  onClick: () => void;
  /** Override the default PlusIcon */
  icon?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

export function ButtonCreateEntity({
  label,
  onClick,
  icon,
  className,
  disabled = false,
  isLoading = false,
}: ButtonCreateEntityProps) {
  return (
    <Button
      type="button"
      variant="default"
      className={cn('gap-2', className)}
      onClick={onClick}
      disabled={disabled || isLoading}>
      {isLoading ? (
        <Spinner className="size-4" />
      ) : (
        icon ?? <PlusIcon className="size-4" />
      )}
      {label}
    </Button>
  );
}
